import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
}
export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  children,
  className = '',
  disabled,
  ...props
}) => {
  const baseStyles = 'min-h-[48px] px-6 py-3 rounded-xl font-semibold text-base tracking-wide transition-all duration-200 focus:outline-none focus:ring-4 disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center gap-2';
  const variantStyles = {
    primary: 'bg-teal-deep text-white shadow-md hover:brightness-110 focus:ring-teal-deep/30',
    secondary: 'bg-transparent border-2 border-teal-deep text-teal-deep hover:bg-teal-deep/10 focus:ring-teal-deep/30'
  };
  return <button className={`${baseStyles} ${variantStyles[variant]} ${className}`} disabled={disabled} {...props} data-id="element-591">
      {children}
    </button>;
};